export default {
	data() {
		return {
			defaultPageTitle: 'One Stop Shop'
		};
	},

	head() {
		let title = this.defaultPageTitle;
		if (this.shopConfig && this.shopConfig.hasOwnProperty('festivalData')) {
			title = `${this.shopConfig.festivalData.title} | One Stop Shop`;
		}
		const metaData = {
			title: title
		};

		if (this.ossConfig?.favicon && this.ossConfig?.favicon?.fields) {
			const { file } = this.ossConfig.favicon.fields;

			metaData.link = [
				{ name: 'msapplication-TileColor', content: '#282835' },
				{ name: 'msapplication-TileImage', content: `https:${file.url}` },
				{ name: 'theme-color', content: '#282835' },
				{ rel: 'icon', type: 'image/x-icon', href: `https:${file.url}` }
			];
		}

		return {
			...metaData,
			meta: [
				{ hid: 'og:site_name', property: 'og:site_name', content: metaData.title },
				{ hid: 'og:title', property: 'og:title', content: metaData.title },
				{ hid: 'og:description', property: 'og:description', content: `${metaData.title} One Stop Shop` },
				{ hid: 'description', name: 'description', content: `${metaData.title} One Stop Shop` }
			]
		};
	},

	computed: {
		ossConfig() {
			return this.$store.getters.getOssConfig;
		},

		shopConfig() {
			return this.$store.getters.shopConfig;
		}
	}
};
